import {
	emailSendCustomerReportBadData,
	EmailSendCustomerReportBadDataProps
} from '@/modules/email/emailActions';
import type { RootState } from '@/rootReducer';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

export const useReportDataMutation = () => {
	const dispatch = useDispatch();

	const mutate = (props: EmailSendCustomerReportBadDataProps) => {
		dispatch(emailSendCustomerReportBadData(props));
	};

	const { isLoading, isSuccess, isError } = useSelector<
		RootState,
		{ isLoading: boolean; isSuccess: boolean; isError: boolean }
	>(
		state => ({
			isLoading: state.email.getIn(['reportBadData', 'loading']),
			isSuccess: state.email.getIn(['reportBadData', 'success']),
			isError: state.email.getIn(['reportBadData', 'failure'])
		}),
		shallowEqual
	);

	return { mutate, isLoading, isSuccess, isError };
};
